import React from 'react';
import './styles.scss';
import TripHistoryCardDetails from './trip-history-card-details';
import TripHistoryCardFooter from './trip-history-card-footer';
import { TripHistoryType } from 'models/trip-history.model';

type Props = {
  tripHistory: TripHistoryType;
};
const TripHistoryCard = ({ tripHistory }: Props) => {
  return (
    <div role='link' className='trip-history-card relative'>
      <TripHistoryCardDetails tripDetails={tripHistory} />
      <TripHistoryCardFooter tripDetails={tripHistory} />
    </div>
  );
};

export default TripHistoryCard;
